import { FINSEMBLECONFIG, toGoLangInvoke } from "../common/windowFunctions";
class LoggerSection {
    warn(...args) {
        globalThis.console.warn(...args);
    }
    info(...args) {
        globalThis.console.info(...args);
    }
    log(...args) {
        globalThis.console.log(...args);
    }
    debug(...args) {
        globalThis.console.debug(...args);
    }
    error(...args) {
        globalThis.console.error(...args);
    }
    verbose(...args) {
        globalThis.console.debug(...args);
    }
    deprecated(...args) {
        globalThis.console.error(...args);
    }
}
export class LoggerImpl {
    constructor(gluePromise, asyncConstructors) {
        this.asyncConstructors = asyncConstructors;
        this.queue = [];
        this.logState = {
            Error: true,
            Warn: true,
            Log: true,
            Info: false,
            Debug: false,
            Verbose: false,
            Console: false
        };
        this.componentSelected = false;
        this.centralLoggerReady = false;
        this.enableLegacyLoggerRecipe = false;
        this.routerClient = null;
        const pw = asyncConstructors.addConstructor();
        gluePromise.then(async (g) => {
            this.glue = g;
            const windowName = this.glue.windows?.my()?.name ?? "unknown window";
            await this.glue.contexts.subscribe("central-logger-component-states", ({ componentLogState, componentFilterState }) => {
                if (windowName in componentLogState && windowName in componentFilterState) {
                    this.logState = componentLogState[windowName];
                    this.componentSelected = componentFilterState[windowName];
                    this.centralLoggerReady = true;
                    this.processQueue();
                }
            });
            const manifest = await g.contexts.get(FINSEMBLECONFIG);
            this.enableLegacyLoggerRecipe = manifest.iocd?.enableLegacyLoggerRecipe;
            asyncConstructors.finishConstructor(pw);
        });
        this.system = {
            warn: (...args) => {
                this.logIt("system", "Warn", args);
            },
            info: (...args) => {
                this.logIt("system", "Info", args);
            },
            log: (...args) => {
                this.logIt("system", "Log", args);
            },
            error: (...args) => {
                this.logIt("system", "Error", args);
            },
            debug: (...args) => {
                this.logIt("system", "Debug", args);
            },
            verbose: (...args) => {
                this.logIt("system", "Verbose", args);
            },
            deprecated: (...args) => {
                this.logIt("system", "Error", args);
            },
        };
        this.perf = {
            warn: (...args) => {
                this.logIt("perf", "Warn", args);
            },
            info: (...args) => {
                this.logIt("perf", "Info", args);
            },
            log: (...args) => {
                this.logIt("perf", "Log", args);
            },
            error: (...args) => {
                this.logIt("perf", "Error", args);
            },
            debug: (...args) => {
                this.logIt("perf", "Debug", args);
            },
            verbose: (...args) => {
                this.logIt("perf", "Verbose", args);
            },
            deprecated: (...args) => {
                this.logIt("perf", "Error", args);
            },
        };
        this.console = new LoggerSection();
    }
    logIt(category, logType, logData) {
        const message = {
            category,
            logType,
            logClientName: this.glue?.windows?.my()?.name ?? "",
            logData,
            logTimestamp: new Date().valueOf()
        };
        this.queue.push(message);
        this.processQueue();
    }
    async processQueue() {
        if (!this.centralLoggerReady || this.queue.length === 0) {
            return;
        }
        await this.asyncConstructors.ready();
        const tmpQueue = this.queue.slice(0);
        this.queue = [];
        if (!this.componentSelected) {
            return;
        }
        const data = tmpQueue.filter((log) => this.logState[log.logType]);
        if (data.length) {
            data.forEach((item) => {
                item.logClientName = this.glue?.windows?.my()?.name ?? "";
            });
            const convertToConsole = (logLevel) => {
                const map = {
                    "Error": "error",
                    "Log": "log",
                    "Debug": "debug",
                    "Info": "info",
                    "Warn": "warn",
                    "Verbose": "debug",
                    "Console": "log"
                };
                return map[logLevel];
            };
            if (this.logState["Console"]) {
                data.forEach((datum) => this.console[convertToConsole(datum.logType)](...datum.logData));
            }
            await toGoLangInvoke(() => this.glue.interop.invoke("fsbl-logger-service-log-messages", {
                data
            }));
            if (this.enableLegacyLoggerRecipe) {
                this.routerClient?.transmit("logger.service.logMessages", data.map((item) => {
                    return {
                        ...item,
                        logData: JSON.stringify(item.logData)
                    };
                }));
            }
        }
    }
    warn(...args) {
        this.logIt("dev", "Warn", args);
    }
    info(...args) {
        this.logIt("dev", "Info", args);
    }
    log(...args) {
        this.logIt("dev", "Log", args);
    }
    debug(...args) {
        this.logIt("dev", "Debug", args);
    }
    error(...args) {
        this.logIt("dev", "Error", args);
    }
    verbose(...args) {
        this.logIt("dev", "Verbose", args);
    }
    deprecated(...args) {
        this.logIt("dev", "Error", args);
    }
    initialize(routerClient) {
        this.routerClient = routerClient;
    }
}
